const BASE_TYPES = ["paragraph", "headings_block", "pre_block"];
const BLOCK_LEVEL_SPACING = 3;

const splitProseMirrorTreeIntoChunks = (
  rawText,
  applyOffset = false,
  initialOffset = 0,
) => {
  if (!rawText.content) return [];

  let chunks = [];
  let cumulativeOffset = initialOffset;

  rawText.content?.forEach((node) => {
    const currentOffset = cumulativeOffset + 1;
    const isBlockElement = node.type === "quote_block";

    if (!BASE_TYPES.includes(node.type)) {
      const nestedChunks = splitProseMirrorTreeIntoChunks(
        node,
        applyOffset,
        currentOffset,
      );
      chunks = [...chunks, ...nestedChunks];

      if (applyOffset) {
        cumulativeOffset = nestedChunks.reduce(
          (offset, chunk) => offset + chunk?.text?.length + 1,
          cumulativeOffset,
        );
      }
    }

    const nodeChildText = node?.content?.reduce((acc, next) => {
      if (next.type === "hard_break") return acc + "   ";
      if (next.type === "powerWord_block") return acc + next.content[0].text;
      if (next.type === "keyTerm_block") return acc + next.content[0].text;
      if (!next?.text) return acc;

      return acc + next?.text;
    }, "");

    if (nodeChildText) {
      const chunk = {
        text: nodeChildText,
        identifier: node?.identifier || node?.relativeIdentifier,
        ...(applyOffset && { offset: currentOffset }),
      };
      chunks = [...chunks, chunk];
      cumulativeOffset += nodeChildText?.length + 1;
    }

    cumulativeOffset += isBlockElement ? BLOCK_LEVEL_SPACING : 1;
  });

  return chunks;
};

export default splitProseMirrorTreeIntoChunks;
